import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import s from './styles.less';

const propTypes = {
  paths: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      to: PropTypes.string,
    }).isRequired,
  ).isRequired,
};

const Breadcrumbs = ({ paths }) => (
  <ol className={s.breadcrumb}>
    {paths.map(({ name, to }) => (
      <li key={name}>
        {to && <Link to={to}>{name}</Link>}
        {!to && name}
      </li>
    ))}
  </ol>
);

Breadcrumbs.propTypes = propTypes;

export default Breadcrumbs;
